<mat-sidenav-container>
    <mat-sidenav #sidenav mode="side" [ngClass]="{'sidenav-full': opened, 'sidenav-collapsed': !opened}"
        [style.width]="opened ? '290px' : '70px'" fixedInViewport="true" [fixedTopGap]="0" opened>
        <!-- Barra lateral izquierda -->
        <mat-toolbar>
            <mat-toolbar-row [ngClass]="{'toolbar-row-full': opened, 'toolbar-row-collapsed': !opened}">
                <a routerLink={{route}}>
                    <img class="useitLogo" [ngClass]="{'logo-full': opened, 'logo-collapsed': !opened}"
                        src="img/serveto2.png" alt="useit_ia">
                </a>
                <button mat-icon-button class="toggle-button" [ngClass]="{'button-shifted': !opened}"
                    (click)="toggleSidenav()">
                    <mat-icon class="menu_open">{{ opened ? 'menu_open' : 'menu' }}</mat-icon>
                </button>
            </mat-toolbar-row>
            <mat-toolbar-row>
                <mat-divider class="divider"></mat-divider>
            </mat-toolbar-row>
        </mat-toolbar>

        <mat-nav-list>
            @for(option of pageMenu?.options; track option.title){
            @if(option.isExpandable && option.subsections && option.subsections.length > 0){
            <div class="menu-item">
                <mat-list-item class="items parent-item" [class.active]="isParentActive(option)"
                    (click)="toggleSubmenu(option)">
                    @if (option.not_svg) {
                    <mat-icon class="logo" style="color: #e8eaed;">{{ option.icon }}</mat-icon>
                    } @else {
                    <mat-icon class="logo" svgIcon="{{ option.icon }}"></mat-icon>
                    }
                    <span class="texto" [ngClass]="{'hidden': !opened}">{{ option.title }}</span>
                    @if (opened) {
                    <mat-icon class="expand-icon">
                        {{ option.expanded ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                    }
                </mat-list-item>

                <div class="submenu" [ngClass]="{'submenu-expanded': option.expanded && opened}">
                    @for(subsection of option.subsections; track subsection.title){
                    <mat-list-item class="items child-item" [routerLink]="subsection.link" routerLinkActive="active"
                        ariaCurrentWhenActive="page">
                        <div class="child-item-content" [ngClass]="{'child-item-collapsed': !opened}">
                            <span class="texto submenu-text" [ngClass]="{'hidden': !opened}">{{ subsection.title
                                }}</span>
                            @if (subsection.identifier === 'inbox' && pendingSuggestions > 0) {
                                <span class="notification-badge">
                                    {{ pendingSuggestions }}
                                </span>
                            }
                        </div>
                    </mat-list-item>
                    }
                </div>
            </div>
            } @else {
            <mat-list-item class="items" [routerLink]="option.link" routerLinkActive="active"
                ariaCurrentWhenActive="page">
                <mat-icon class="logo" svgIcon="{{ option.icon }}"></mat-icon>
                <span class="texto" [ngClass]="{'hidden': !opened}">{{ option.title }}</span>
            </mat-list-item>
            }
            }
        </mat-nav-list>
        <!-- Contenido inferior con el divider y el botón de Cerrar sesión -->
        <div class="content">
            <mat-divider [ngClass]="{'divider-full': opened, 'divider-collapsed': !opened}"></mat-divider>
            <p [ngClass]="{'version-tag': opened, 'version-tag-collapsed': !opened}">
                @if (environment != ''){
                @if (opened){
                {{environment}} - {{version}}
                } @else {
                <span class="env">{{environment}}</span>
                <span class="dash">-</span>
                <span class="ver">{{version}}</span>
                }
                } @else {
                {{version}}
                }
            </p>
            <mat-toolbar-row>
                <button class="boton items logout" [ngClass]="{'boton-full': opened, 'boton-collapsed': !opened}"
                    (click)="logout()">
                    <mat-icon class="logo">exit_to_app</mat-icon>
                    <span class="texto" [ngClass]="{'hidden': !opened}">Cerrar sesión</span>
                </button>
            </mat-toolbar-row>
        </div>
    </mat-sidenav>

    <mat-sidenav-content [ngClass]="{'content-normal': opened, 'content-expanded': !opened}"
        [style.margin-left]="opened ? '290px' : '70px'">
        <!-- Resto contenido derecha -->
        <!-- Poner aquí el contenido de las rutas -->
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>